import React from 'react';
import { Quote, Star } from 'lucide-react';
type StarRowProps = {
  className?: string;
};
function StarRow({
  className = ''
}: StarRowProps) {
  return <div className={`flex gap-1 ${className}`} aria-label="Five-star review" data-id="element-94">
      {Array.from({
      length: 5
    }, (_, index) => <Star key={index} size={14} className="fill-current" aria-hidden="true" data-id="element-95" />)}
    </div>;
}
export function Reviews() {
  return <section id="reviews" aria-labelledby="reviews-heading" className="bg-[#f4f0e7] py-20 sm:py-28" data-id="element-96">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-97">
        <div className="grid gap-6 border-b border-[#c9c3b4] pb-10 md:grid-cols-[0.8fr_1.2fr] md:items-end" data-id="element-98">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#356d70]" data-id="element-99">
            In their words
          </p>
          <h2 id="reviews-heading" className="max-w-2xl text-4xl font-medium tracking-[-0.045em] text-[#173d36] sm:text-5xl" data-id="element-100">
            The work feels different when it is made around real life.
          </h2>
        </div>

        <div className="grid lg:grid-cols-[1.25fr_0.75fr]" data-id="element-101">
          <figure className="border-b border-[#c9c3b4] py-10 lg:border-b-0 lg:border-r lg:py-14 lg:pr-14" data-id="element-102">
            <Quote size={38} strokeWidth={1.25} className="text-[#356d70]" aria-hidden="true" data-id="element-103" />
            <blockquote className="mt-7 max-w-3xl text-xl leading-8 tracking-[-0.02em] text-[#173d36] sm:text-2xl sm:leading-9" data-id="element-104">
              “When I learned about natural swimming pools, here in AZ, at a
              home show in 2020, I knew I wanted to work with Zach to realize
              the dream of a chemical free pool. We kept in touch for 3 years as
              I organized for a large yard/pool remodel. Zach was professional,
              knowledgable, and offered friendly support as well, throughout the
              entire process from design to finish. He continues to provide
              weekly pool service to keep my pool and biofilter working
              perfectly. As a naturopathic doctor with sensitive skin, a natural
              pool was the natural choice! Even if you’re not sure if you’re
              ready for a natural pool conversion or new build, if you have pool
              service needs, I highly recommend Zach and Natural Swimming
              Pools.”
            </blockquote>
            <figcaption className="mt-8 flex items-center gap-4" data-id="element-105">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#173d36] text-sm font-medium text-[#8de0e5]" data-id="element-106">
                JM
              </span>
              <span data-id="element-107">
                <strong className="block text-sm font-semibold text-[#173d36]" data-id="element-108">
                  Julie Murphy
                </strong>
                <StarRow className="mt-1 text-[#356d70]" data-id="element-109" />
              </span>
            </figcaption>
          </figure>

          <div className="divide-y divide-[#c9c3b4] lg:pl-14" data-id="element-110">
            <article className="py-10 lg:pt-14" data-id="element-111">
              <StarRow className="text-[#356d70]" data-id="element-112" />
              <blockquote className="mt-5 text-lg leading-7 tracking-[-0.01em] text-[#173d36]" data-id="element-113">
                “If you’re looking for someone who is hardworking, experienced,
                and truly cares about client satisfaction, he’s the one. His
                knowledge and attention to detail really set him apart, and he
                takes pride in every project he completes.”
              </blockquote>
              <p className="mt-6 text-sm font-semibold text-[#173d36]" data-id="element-114">
                Kaitlyn Balbini
              </p>
            </article>

            <article className="py-10 lg:pb-14" data-id="element-115">
              <StarRow className="text-[#356d70]" data-id="element-116" />
              <blockquote className="mt-5 text-lg leading-7 tracking-[-0.01em] text-[#173d36]" data-id="element-117">
                “I didn't no chemical free natural pools were possible until I
                met Zach. I was thoroughly impressed with his knowledge,
                experience, and history of natural pools. I would totally
                recommend Zach for any pool build or service for any type of
                pool, chemical, natural, or fiberglass. It's hard to find anyone
                as honest, upfront, and courteous as Zach. I highly recommend
                him.”
              </blockquote>
              <p className="mt-6 text-sm font-semibold text-[#173d36]" data-id="element-118">
                Walt Foster
              </p>
            </article>
          </div>
        </div>
      </div>
    </section>;
}